import React from 'react';
import { Loader, Segment } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

export const Loading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Segment vertical={true}>
      <Loader active={true} inline="centered" size="big">
        {t('ui.expression.loading')}
      </Loader>
    </Segment>
  );
};
